<template>
  <header class="flex min-h-screen flex-col-reverse lg:flex-row">
    <Container class="flex-1 pt-6 sm:pt-8 lg:pt-32">
      <Breadcrumbs class="mb-10 mt-4 md:mt-8 lg:mb-6 lg:mt-14" />

      <AnimatedContainer>
        <h1
          v-if="data.heading"
          class="fade-in max-w-title hyphens-auto text-5xl/10 font-medium sm:text-6xl md:text-7xl lg:pr-14"
          v-html="$replaceHtmlTags(data.heading)"
        />

        <Bard
          v-if="data.text"
          :data="data.text"
          class="fade-in mt-5 text-md sm:mt-6 sm:text-lg"
        />
      </AnimatedContainer>
      <Scrolly v-if="data.button_text" class="mt-10 sm:mt-12 md:mt-10 lg:mt-14">
        {{ data.button_text }}
      </Scrolly>
    </Container>

    <div
      class="w-full pl-container sm:pl-container-desktop lg:w-1/2 xl:w-[55%]"
    >
      <AppImage
        v-if="data.image"
        :alt="$i18n.locale === 'fr' ? data.image.alt_fr : data.image.alt"
        class="h-[65vh] w-full object-cover lg:h-full"
        :src="data.image"
        :style="`object-position: ${data.image.focus_css};`"
      />
    </div>
  </header>
</template>

<script setup>
defineProps({
  data: { type: Object, required: true },
})

const { setIsWhite, setBlackLogo, initWindowResizeWatcher } =
  useNavigationStore()

onMounted(() => {
  initWindowResizeWatcher()
})

onBeforeUnmount(() => {
  setIsWhite(false)
  setBlackLogo(false)
})
</script>
